/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences(
    $data: UpdateNotificationPreferencesInput!
  ) {
    updateNotificationPreferences(data: $data) {
      blockedChannels
    }
  }
`
